module.exports = __webpack_public_path__ + "static/media/img_sms.0a353540.svg";